export function ReturnToTray(Item)
{
    //console.log("destroy called");
    let Scene = Item.scene;
    Scene.addTween(Item,200,{x:Scene.Tray.x,y:Scene.Tray.y, alpha:0},Phaser.Math.Easing.Linear,()=>{
        Item.destroy();
    });
}